import { NgModule } from '@angular/core';
import { DateMaskDirective } from './date-mask.directive';
import { DateFormatPipe } from './date.pipe';
import { DateValidateDirective } from './date-validate.directive';

@NgModule({
    imports: [],
    declarations: [DateMaskDirective, DateFormatPipe, DateValidateDirective],
    exports: [DateMaskDirective],
    providers: [DateFormatPipe],
})
export class DateModule {}
